import React from 'react';
import { Checkbox, FormControlLabel, Grid, TextField } from '@material-ui/core';
import { useFormContext } from '../FormContext';
import FormConfigTitleDescription from './FormConfigTitleDescription';
import FormConfigRequired from './FormConfigRequired';
export const FormConfigTextField = () => {
    var _a;
    const { formState, setFormState, notifyFormEdit } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Placeholder', value: ((_a = element.config) === null || _a === void 0 ? void 0 : _a.placeholder) || '', onChange: event => {
                    element.config.placeholder = event.target.value;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControlLabel, { label: 'Multiple Lines', control: React.createElement(Checkbox, { color: 'primary', checked: Boolean(element.config.multiline), onChange: () => {
                        element.config.multiline = !element.config.multiline;
                        setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                        notifyFormEdit();
                    } }) }))));
};
export default FormConfigTextField;
//# sourceMappingURL=FormConfigTextField.js.map